import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../layout/use-page-title.js';

/**
 * Light privacy policy page for the prerelease service.
 * @returns {JSX.Element}
 */
export function PrivacyPage() {
	const { t } = useTranslation();
	usePageTitle('site.privacy.title', 'site.meta.privacy.description');

	return (
		<section className="terms">
			<h1>{t('site.privacy.title')}</h1>
			<p className="terms-lede">{t('site.privacy.lede')}</p>
			<div className="terms-body">
				<p>{t('site.privacy.p1')}</p>
				<p>{t('site.privacy.p2')}</p>
				<p>{t('site.privacy.p3')}</p>
				<p>{t('site.privacy.p4')}</p>
			</div>
			<p className="terms-governing">{t('site.privacy.governingNote')}</p>
		</section>
	);
}
